import { render, staticRenderFns } from "./RegistrationInfo.vue?vue&type=template&id=c47a7af4&"
import script from "./RegistrationInfo.vue?vue&type=script&lang=js&"
export * from "./RegistrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports